import { FC } from 'react'

import { FieldError } from 'react-hook-form'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface CitizenshipFieldProps {
  label: string
  value?: string
  error?: FieldError
  onSelect: () => void
}

export const CitizenshipField: FC<CitizenshipFieldProps> = ({
  label,
  value,
  error,
  onSelect,
}) => (
  <div className={s.root}>
    <button
      type="button"
      className={clsx(s.field, value && s.hasValue, error && s.error)}
      aria-invalid={Boolean(error)}
      onClick={onSelect}
    >
      <span className={clsx(s.label, value ? 'regular-12' : 'medium-16')}>
        {label}
      </span>
      {value ? (
        <span className={clsx(s.value, 'medium-16')}>{value}</span>
      ) : null}
      <AppIcon
        id={AllIcons.ARROW_RIGHT}
        className={s.arrow}
        width={24}
        height={24}
      />
    </button>
    {error?.message ? (
      <p className={clsx(s.errorText, 'regular-12')}>{error.message}</p>
    ) : null}
  </div>
)
